// Modal.js
import React from 'react';
import './Modal.css';
import ReactDOM from "react-dom";

const GeneriqueModal = ({ isOpen, onClose, title, children }) => {
    const handleOverlayClick = (e) => {
        // Ne pas fermer si on clique sur le contenu du modal
        if (!e.target.classList.contains('modal-overlay')) {
            return;
        }
        
        // Vérifier si un menu react-select est ouvert
        try {
            const reactSelectMenu = document.querySelector('.react-select__menu');
            const reactSelectMenuPortal = document.querySelector('[id*="react-select"]');
            
            // Vérifier si un menu est visible
            const isMenuOpen = 
                (reactSelectMenu && reactSelectMenu.offsetParent !== null) ||
                (reactSelectMenuPortal && reactSelectMenuPortal.offsetParent !== null);
            
            if (isMenuOpen) {
                // Fermer le menu en cliquant sur le contrôle
                try {
                    const selectControl = document.querySelector('.react-select__control');
                    if (selectControl) {
                        selectControl.click();
                    }
                } catch (err) {
                    // Erreur silencieuse
                }
                // Ne pas fermer le modal si un menu est ouvert
                return;
            }
        } catch (error) {
            // Erreur silencieuse
        }
        
        // Fermer le modal seulement si aucun menu n'est ouvert
        onClose();
    };

    return (
        <>
            {isOpen && ReactDOM.createPortal(
                <div className="modal-overlay px-4" onClick={handleOverlayClick}>
                    <div
                        className="bg-white w-max-width generique-modal-surface"
                        onClick={(e) => e.stopPropagation()}
                        style={{ borderRadius: '20px', padding: "40px" }}
                    >
                        <h2 className="modal-header me-5">{title}</h2>
                        <hr />
                        <div className="generique-modal-content">{children}</div>
                    </div>
                </div>, document.getElementById("modal-root")
            )}
        </>
    );
};

export default GeneriqueModal;
